import React, { useContext, useState } from 'react'
import { Button } from '@ticketswap/solar'
import StackedCards from '~/components/FacebookEvents/StackedCards'
import userError from '~/graphql/fragments/userError'
import { useMutation, gql } from '@apollo/client'
import { useViewer } from '~/components/ViewerContext'
import { Facebook } from '@ticketswap/comets'
import { track } from '~/utils'
import { FACEBOOK_EVENTS_CONNECTED } from '~/lib/tracking-events'
import { FacebookContext } from '~/components/FacebookContext'

const CONNECT_FACEBOOK_ACCOUNT = gql`
  mutation connectFacebookAccount($input: ConnectFacebookAccountInput!) {
    connectFacebookAccount(input: $input) {
      user {
        id
        facebookUserPermissions {
          handle
          granted
        }
        facebookUserEvents {
          edges {
            node {
              id
            }
          }
        }
      }
      errors {
        ...userError
      }
    }
  }
  ${userError}
`

const ConnectFacebookCard = ({ t }) => {
  const { mergeViewer } = useViewer()
  const [connectFacebook] = useMutation(CONNECT_FACEBOOK_ACCOUNT)
  const { login } = useContext(FacebookContext)
  const [loading, setLoading] = useState(false)

  const handleCompleted = async ({ accessToken }) => {
    const { data } = await connectFacebook({
      variables: {
        input: {
          facebookAccessToken: accessToken,
        },
      },
    })

    setLoading(false)

    if (data) {
      mergeViewer(data.connectFacebookAccount.user)
      const events = data.connectFacebookAccount.user.facebookUserEvents?.edges

      track(FACEBOOK_EVENTS_CONNECTED, {
        hasEvents: events.length > 0,
      })
    }
  }

  return (
    <StackedCards
      t={t}
      title={t('home:facebookEvents.notConnected.title')}
      text={t('home:facebookEvents.notConnected.text')}
      button={
        <Button
          loading={loading}
          variant="facebook"
          size="small"
          leftAdornment={<Facebook size={16} />}
          onClick={async () => {
            setLoading(true)
            try {
              const response = await login({
                scope: 'user_events',
                auth_type: 'rerequest',
              })
              await handleCompleted(response)
            } catch {
              setLoading(false)
            }
          }}
        >
          {t('home:facebookEvents.notConnected.button')}
        </Button>
      }
    />
  )
}

export default ConnectFacebookCard
